import { render, staticRenderFns } from "./GlobalBlockInput.vue?vue&type=template&id=52c6b2f0&"
import script from "./GlobalBlockInput.vue?vue&type=script&lang=ts&"
export * from "./GlobalBlockInput.vue?vue&type=script&lang=ts&"
import style0 from "./GlobalBlockInput.vue?vue&type=style&index=0&id=52c6b2f0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports